{
  "name": "launchdarkly-react-client-sdk",
  "version": "3.0.6",
  "description": "LaunchDarkly SDK for React",
  "author": "LaunchDarkly <team@launchdarkly.com>",
  "license": "Apache-2.0",
  "keywords": [
    "launchdarkly",
    "launch",
    "darkly",
    "react",
    "sdk",
    "bindings"
  ],
  "main": "lib/index.js",
  "types": "lib/index.d.ts",
  "files": [
    "lib",
    "src",
    "!**/*.test.*",
    "!**/__snapshots__"
  ],
  "scripts": {
    "test": "jest",
    "test:junit": "jest --ci --reporters=default --reporters=jest-junit",
    "build": "rimraf lib/* && tsc && mv lib/src/* lib && rimraf lib/package.json lib/src lib/*.test.*",
    "lint": "tslint -p tsconfig.json 'src/**/*.ts*'",
    "lint:all": "npm run lint",
    "check-typescript": "tsc",
    "prepublishOnly": "npm run build",
    "prettier": "prettier --write 'src/*.@(js|ts|tsx|json|css)'",
    "link-dev": "./link-dev.sh",
    "check": "npm i && npm run prettier && npm run lint && tsc && npm run test"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/launchdarkly/react-client-sdk.git"
  },
  "homepage": "https://github.com/launchdarkly/react-client-sdk",
  "devDependencies": {
    "@testing-library/jest-dom": "^5.16.4",
    "@testing-library/react": "^13.0.1",
    "@types/hoist-non-react-statics": "^3.3.1",
    "@types/jest": "^27.0.3",
    "@types/lodash.camelcase": "^4.3.6",
    "@types/prop-types": "^15.7.4",
    "@types/react": "^18.0.3",
    "@types/react-dom": "^18.0.0",
    "@types/react-test-renderer": "^18.0.0",
    "jest": "^27.4.4",
    "jest-environment-jsdom": "^27.4.4",
    "jest-environment-jsdom-global": "^3.0.0",
    "jest-junit": "^13.0.0",
    "prettier": "^1.18.2",
    "prop-types": "^15.7.2",
    "react": "^18.0.0",
    "react-dom": "^18.0.0",
    "react-test-renderer": "^18.0.0",
    "rimraf": "^3.0.0",
    "ts-jest": "^27.1.1",
    "tslint": "^6.1.3",
    "tslint-config-prettier": "^1.18.0",
    "tslint-plugin-prettier": "^2.3.0",
    "typescript": "^4.5.3"
  },
  "dependencies": {
    "hoist-non-react-statics": "^3.3.2",
    "launchdarkly-js-client-sdk": "^3.1.3",
    "lodash.camelcase": "^4.3.0"
  },
  "peerDependencies": {
    "react": "^16.6.3 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.4 || ^17.0.0 || ^18.0.0"
  }
}
